"use client";

import { Container } from "@/components/ui/container";
import { Reveal } from "@/components/ui/reveal";
import { Icon } from "@/components/ui/icon";
import { industries } from "@/lib/data/homepage";

/**
 * Industries — 8 industry cards in 4×2 grid. Each card has icon,
 * title, and a stylized industry-specific stat (e.g., "↑ 412%
 * penetration", "24/7/365 support").
 */
export function Industries() {
  const stats = [
    { value: "+412%", label: "Trust", color: "var(--color-emerald)" },
    { value: "+387%", label: "Brand", color: "var(--color-purple)" },
    { value: "+456%", label: "Voter", color: "var(--color-amber)" },
    { value: "+498%", label: "Personal", color: "var(--color-gold)" },
    { value: "+401%", label: "Strategic", color: "var(--color-emerald)" },
    { value: "+389%", label: "Patient", color: "var(--color-cyan)" },
    { value: "+445%", label: "Investor", color: "var(--color-crimson)" },
    { value: "+423%", label: "Talent", color: "var(--color-coral)" },
  ];
  const accents = [
    "var(--color-crimson)",
    "var(--color-purple)",
    "var(--color-amber)",
    "var(--color-gold)",
    "var(--color-emerald)",
    "var(--color-cyan)",
    "var(--color-crimson)",
    "var(--color-coral)",
  ];
  return (
    <section id="industries" className="relative section-pad">
      <Container>
        <Reveal className="text-center max-w-3xl mx-auto mb-12">
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full glass eyebrow-tiny text-[var(--color-cyan)]">
            <span className="h-1.5 w-1.5 rounded-full bg-[var(--color-cyan)]" />
            Industry Applications
          </span>
          <h2 className="mt-5 text-[clamp(2rem,4.5vw,3.2rem)] font-bold leading-[1.04] tracking-[-0.025em]">
            Tailored for Your Sector
          </h2>
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {industries.map((ind, i) => (
            <Reveal key={ind.title} delay={i * 50}>
              <div
                className="rounded-2xl glass p-5 h-full relative overflow-hidden card-glow"
                style={{ ["--glow" as string]: accents[i] }}
              >
                <div className="flex items-start justify-between mb-3">
                  <Icon name={ind.icon} className="h-7 w-7" style={{ color: accents[i] }} />
                  <div className="text-right">
                    <div className="display-stat-sm" style={{ color: stats[i].color }}>
                      {stats[i].value}
                    </div>
                    <div className="eyebrow-tiny opacity-80 text-[rgb(var(--fg-subtle))] font-semibold mt-0.5">
                      {stats[i].label}
                    </div>
                  </div>
                </div>
                <h3 className="font-bold text-base leading-tight mb-2">{ind.title}</h3>
                <p className="text-caption leading-relaxed text-[rgb(var(--fg-muted))]">{ind.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </Container>
    </section>
  );
}
